
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 22.5C1 34.355 10.645 44 22.499 44 34.355 44 44 34.355 44 22.5S34.355 1 22.499 1C10.645 1 1 10.645 1 22.5zM22.499 3C33.251 3 42 11.75 42 22.5S33.25 42 22.499 42C11.749 42 3 33.25 3 22.5S11.75 3 22.499 3z","fill":"#DC143C"}}),_c('path',{attrs:{"d":"M21.785 28.865C21.4 21.41 20.14 15.775 20.14 12.52c0-1.715.7-2.52 1.925-2.52 1.19 0 1.925.805 1.925 2.52 0 3.255-1.26 8.89-1.68 16.345h-.525zm.28 7.07c-1.155 0-2.065-.91-2.065-2.03 0-1.12.91-2.03 2.065-2.03 1.12 0 2.03.91 2.03 2.03 0 1.12-.91 2.03-2.03 2.03z","fill":"#DC143C"}})])
          )
        }
      }
    